{
  "apiUrl": "/bp-api",
  "environment": "local",
  "auth": {
    "audience": "https://archintegrate-nonprod.archinsurance.com",
    "issuer": "https://archinsurance-dev.auth0.com/",
    "clientId": "hpZ3JHZa2dVswsQFIeriaQDw8q419QEs",
    "grant_type": "client_credentials"
  }
}
